export default "__VITE_ASSET__K8AXf4gz__"